import React from "react";

export function Card({
  className = "",
  children,
  ...rest
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={`bg-white dark:bg-slate-800 rounded-xl shadow-card border border-slate-100 dark:border-slate-700 ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
}

export function CardHeader({
  className = "",
  children,
  ...rest
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={`flex items-center gap-2 px-4 sm:px-5 pt-4 sm:pt-5 ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
}

export function CardContent({
  className = "",
  children,
  ...rest
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={`px-4 sm:px-5 py-4 sm:py-5 ${className}`} {...rest}>
      {children}
    </div>
  );
}
